export class MerchantConsoleApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Resolve the authenticated merchant user's operating context at a merchant (realm-isolated server-side). */
    context(merchantId) {
        return this.client.request({ method: 'GET', path: `/v1/merchant/context?merchantId=${encodeURIComponent(merchantId)}`, auth: true });
    }
    /**
     * Grant a staff membership (operator, or the store's owner/manager). D446 (M-11): invite by `identifier` (the person's
     * MERCHANT sign-in — `OPERATOR_NOT_FOUND` / `OPERATOR_REALM_MISMATCH`); an owner or manager also receives the MERCHANT
     * grant; a manager never grants an owner (`STAFF_ROLE_INSUFFICIENT`); `MEMBERSHIP_ALREADY_ACTIVE` when already on the team.
     */
    grantMembership(input) {
        return this.client.request({ method: 'POST', path: '/v1/merchant/memberships', body: input, auth: true });
    }
    /** List a merchant's staff memberships (operator). */
    listMemberships(merchantId) {
        return this.client.request({ method: 'GET', path: `/v1/merchant/memberships?merchantId=${encodeURIComponent(merchantId)}`, auth: true });
    }
    /** Revoke a membership (append-only). D446 (M-11): the person's MERCHANT grant goes with their last owner/manager membership. */
    revokeMembership(membershipId) {
        return this.client.request({ method: 'POST', path: `/v1/merchant/memberships/${encodeURIComponent(membershipId)}/revoke`, body: {}, auth: true });
    }
}
//# sourceMappingURL=merchant-console.js.map